import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { initTempDashboard } from '@store/trends/tempDashboard/alertDiagnostics/actions';
import tempDashboardSelector, {
  alertDiagnosticsUpdateSelector,
} from '@store/trends/tempDashboard/alertDiagnostics/selectors';
import { DASHBOARD_TYPE } from '@utils/constants';
import tempDashboard from '@src/pages/common/tempDashboard';
import { Main } from '@src/pages';
import initStore from './initStore';

const alertDiagnosticsDetailsSelector = createSelector(
  alertDiagnosticsUpdateSelector,
  tempDashboardSelector,
  (dashboard, tempDashboardStore) => ({
    dashboard,
    dashboardType: DASHBOARD_TYPE.ALERT_DIAGNOSTICS,
    isFetching: tempDashboardStore.isFetching,
    initStore,
  }),
);

export const TempAlertDiagnostics = compose(
  connect(alertDiagnosticsDetailsSelector, { init: initTempDashboard }),
  tempDashboard,
)(Main);
